import { useEffect, useRef } from "react";
import gsap from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import {WelcomeHero} from "./initialWelcomeMessage";

import Marquee from "react-fast-marquee";

import { Vortex } from "./background"




gsap.registerPlugin(ScrollTrigger);


const Hero: React.FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const heroRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!containerRef.current || !heroRef.current) return;

        gsap.timeline(

            {
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top top",
                end: "+=200%",
                scrub: true,
                pin: true,
                anticipatePin: 1,
            },
        })
            .to(heroRef.current, {
                scale: 0.5,
                borderRadius: 40 ,
                ease: "power1.out",
            })
            // .to(
            //     heroRef.current.querySelector("h1"),
            //     { opacity: 0, ease: "power1.out" },
            //     "<"
            // );

        return () => {
            ScrollTrigger.getAll().forEach((st) => st.kill());
        };
    }, []);

    return (
        <div ref={containerRef} className="w-full min-h-screen pb-[180vh] v-10">
            {/* HERO (pinned + zoomed out) */}
            <div
                ref={heroRef}
                className="relative z-20 w-full min-h-screen flex items-center justify-center bg-[#701f84]/60 overflow-hidden"
            >
                <div className="w-full">
                    < WelcomeHero />
                </div>

            </div>

            {/* BACKGROUND SECTION revealed underneath */}
            <div className="absolute text-9xl top-0 left-0 w-full min-h-[100vh] z-0 bg-[#00000000] flex flex-col items-center justify-center">
                <Vortex
                    backgroundColor="transparent"
                    particleCount={700}
                    baseHue={220}
                    baseSpeed={0.0}
                    rangeSpeed={1.5}
                    className="flex items-center justify-center w-full h-full"
                >
                    <Marquee gradient={true} gradientColor={"transparent"} speed={150}>
                      <span className="bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 bg-clip-text text-transparent whitespace-nowrap">
                        RGU MOTORSPORTS
                      </span>
                    </Marquee>
                </Vortex>
            </div>
        </div>
    );
};

export default Hero;
